import * as React from 'react';

const TicketsRoundIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 120 120" {...props}>
        <defs>
            <linearGradient
                id="tickets-round-illustration_svg__linear-gradient"
                x1={35.64}
                y1={102.67}
                x2={84.55}
                y2={17.95}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#0d2223" stopOpacity={0.2} />
                <stop offset={1} stopColor="#0d2223" stopOpacity={0} />
            </linearGradient>
        </defs>
        <circle cx={59.93} cy={60.03} r={48.89} fill="#70e4e0" />
        <path
            d="M15.42 39.83a48.89 48.89 0 1093.36 20.34 54.23 54.23 0 00-.31-6.41c-5.33 3.19-5.8 23.74-14.8 19.86-1.94-5.69 2.88-16.74-3-20.16C86.38 51 73.86 69.38 69.06 70.18 37.24 75.49 75.6 24.49 66.57 19c-7.35-4.47-24 31-34 33.51-12 3 5.48-20.76.87-24.48-3.34-2.69-14.44 8.61-18.02 11.8z"
            fill="#00d8d2"
        />
        <circle
            cx={60.1}
            cy={60.31}
            r={48.9}
            fill="url(#tickets-round-illustration_svg__linear-gradient)"
        />
        <path
            d="M38.61 39.84l.82-.86a7 7 0 001.62-4.72v-1.19a7 7 0 011-3.93l1-1.64 1.84 1.22 4.85-5.25s5.58 7.9 2.14 11.91c-3 3.51-6.76 8.24-6.76 8.24z"
            fill="#fcc11c"
        />
        <path
            d="M49.38 18.74c-.11.42-.32.74-.59.67s-.32-.39-.34-.81a9.49 9.49 0 00-1.45 0 16.82 16.82 0 01-2.42 9.86A15.27 15.27 0 0047 29.72c.89-.8 3.48-5.83 4.39-10a5.66 5.66 0 00-2.01-.98z"
            fill="#f58626"
        />
        <path
            d="M42.08 29.12s2.38-3.9 3-4.79c.39-.59 2.36.47.38 4.19-.49.92 0 1.06-.56 1.58-1.78 1.76-2.82-.98-2.82-.98z"
            fill="#fcc11c"
        />
        <path
            d="M44.15 25.76c.42-.67.76-1.21.9-1.44.83.5-.15 1.8-.15 1.8z"
            fill="#fbe986"
        />
        <path
            d="M78.95 82.6l.28-.34a11.36 11.36 0 002.62-7.62l-.06-1.92a11.36 11.36 0 011.69-6.33l1.63-2.64 3 2 7.82-8.47s4.4 5.58 4.44 9.13 3.6 5.91-1 10.08c-5.52 5-10.91 13.29-10.91 13.29z"
            fill="#892a10"
        />
        <path
            d="M86.48 95.41l2-5.66s-.88-7.9-9.56-7.19l-4.8 4.61z"
            fill="#00aaac"
        />
        <path
            d="M91.32 50.74a78.68 78.68 0 01-4.89 14.69 37 37 0 005.11 2.27s4.12-7.17 9.57-14.82a19.22 19.22 0 00-9.79-2.14z"
            fill="#f58626"
        />
        <path
            d="M83.5 66.34s3.84-6.28 4.79-7.73c.62-.94 3.81.75.62 6.76-.79 1.49-.06 1.71-.9 2.55-2.83 2.84-4.51-1.58-4.51-1.58z"
            fill="#892a10"
        />
        <path
            d="M86.83 60.93c.68-1.09 1.22-2 1.46-2.32 1.34.81-.24 2.9-.24 2.9zM67.35 43.47l.35-.42a13.94 13.94 0 003.21-9.35l-.07-2.36a13.94 13.94 0 012.08-7.77l2.21-3.2 3.43 2.38 9.59-10.39s5.4 6.85 5.45 11.2 4.4 7.25-1.23 12.37C85.61 42.08 79 52.23 79 52.23z"
            fill="#bf4c28"
        />
        <path
            d="M89.32.67c-.32.93-1.26 2-2.07 1.9S86 1.23 86 .29a21.28 21.28 0 00-4.29.15 31.86 31.86 0 01-6.43 21.75A50.85 50.85 0 0082.4 25c2-2.67 10.21-12.94 12.85-22.2A19.26 19.26 0 0089.32.67z"
            fill="#f58626"
        />
        <path fill="#bf4c28" d="M74.76 61.9l4.23-9.67-11.64-8.76-8.17 7.79" />
        <path
            d="M74.18 87.17c-4.35 4.27-13.92 13.45-22 21.14a49.24 49.24 0 007.73.61 48.66 48.66 0 0023.91-6.24l2.6-7.32s-2.68-9.25-12.24-8.19z"
            fill="#007f8a"
        />
        <path
            d="M38.65 39.87l-27 27.56a48.67 48.67 0 0010.43 23.5l23.1-47.28s-1.18-4.22-6.53-3.78z"
            fill="#00acaf"
        />
        <path
            d="M20.13 88.44a48.85 48.85 0 0034.18 20.16l20.44-46.7s-3.84-10.41-15.58-10.65c.01.01-39.04 37.19-39.04 37.19z"
            fill="#f8a51e"
        />
        <path
            d="M86.41 95.76a.38.38 0 01-.36-.27c-.11-.37-2.74-8.93-11.86-7.91a.38.38 0 01-.08-.76c9.76-1.09 12.64 8.36 12.67 8.46a.38.38 0 01-.26.47z"
            fill="#045f66"
        />
        <path
            d="M67.39 43.78l.35-.42A13.94 13.94 0 0070.95 34l-.07-2.36A13.94 13.94 0 0173 23.88l2-3.24 3.63 2.42 9.59-10.39s5.4 6.85 5.45 11.2 4.33 7.24-1.25 12.36c-6.77 6.15-25.03 7.55-25.03 7.55z"
            fill="#bf4c28"
        />
        <path
            d="M89.36 1c-.32.93-1.26 2-2.07 1.9S86.07 1.53 86 .6a21.28 21.28 0 00-4.29.15A31.86 31.86 0 0175.3 22.5a50.85 50.85 0 007.15 2.82c2-2.67 10.21-12.94 12.85-22.2A19.26 19.26 0 0089.36 1z"
            fill="#f8a51e"
        />
        <path
            d="M73 23.82s4.71-7.71 5.88-9.48c.76-1.16 4.67.92.76 8.29-1 1.82-.07 2.1-1.1 3.13C75 29.25 73 23.82 73 23.82z"
            fill="#bf4c28"
        />
        <path
            d="M77.07 17.19c.83-1.33 1.5-2.4 1.79-2.84 1.64 1-.29 3.56-.29 3.56z"
            fill="#f6682f"
        />
        <path
            d="M75.73 60.37l-.07-.2c0-.13-.12-.33-.21-.58-.19-.5-.46-1.21-.85-2-.19-.41-.42-.85-.66-1.31s-.53-.92-.84-1.39c-.15-.24-.32-.47-.48-.71s-.34-.47-.52-.7-.37-.46-.57-.68l-.3-.33-.31-.32c-.2-.22-.42-.41-.63-.62l-.67-.57c-.24-.17-.45-.36-.69-.52s-.46-.33-.7-.47a15.4 15.4 0 00-1.4-.77l-.68-.31-.65-.26c-.21-.09-.42-.14-.61-.21s-.38-.13-.56-.17c-.36-.09-.67-.19-.93-.24l-.82-.18a.32.32 0 01.08-.64h.88c.28 0 .62.06 1 .11.2 0 .4.07.62.11s.45.08.68.15l.73.2c.25.08.5.18.77.27a12.58 12.58 0 011.6.75 14 14 0 011.58 1c.25.2.5.41.75.62s.49.43.71.67.45.47.66.72.41.5.61.75a15.14 15.14 0 011 1.55 16.11 16.11 0 01.81 1.54c.23.5.43 1 .59 1.44s.29.87.4 1.25.18.71.24 1 .09.49.11.64v.23a.37.37 0 01-.72.16z"
            fill="#f06a33"
        />
    </svg>
);

TicketsRoundIllustrationSvg.displayName = 'TicketsRoundIllustrationSvg';
export default TicketsRoundIllustrationSvg;
